<template>
  <div class="row">
    <!--  导师信息  -->
    <div class="flex xs10 offset--xs1">
      <va-card title="申请导师">
        <div class="row">

          <div class="flex md6 sm6 xs12">
            <va-input
              label="申请导师性名"
              v-model="insertData.candidate.nickname"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="申请提交时间"
            />
          </div>
        </div>
      </va-card>
    </div>
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class="flex justify--center xs7">
            <va-button-group>
              <va-button outline class="mb-2" color="info" @click="approveModal=true" :disabled="!submitButtonStatus">
                通过申请
              </va-button>
              <va-button outline class="mb-2" color="danger" @click="rejectModal=true" :disabled="!submitButtonStatus">
                拒绝申请
              </va-button>
            </va-button-group>
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.uid'
              v-show="showUid"
              label='uid'
              disabled
            />
          </div>

          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.topic"
              type="textarea"
              label="咨询话题"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.description"
              label="话题详情"
              type="textarea"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.duration"
              label="咨询时长"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.price"
              label="咨询价格"
              disabled
            />
          </div>
        </div>
        <div class="row justify--center">
          <div class="flex md2">
            <va-button class="ma-0" outline color="gray" slot="trigger" @click="$router.push({ name: 'listAuditingConsulting' })" :disabled="!submitButtonStatus">
              返回
            </va-button>
          </div>
        </div>
        <va-modal
          v-model="rejectModal"
          title="拒绝申请"
          okText="提交"
          position="center"
          message="请再次确认是否要拒绝？"
          @ok="confirmReject"
        />
        <va-modal
          v-model="approveModal"
          title="通过申请"
          okText="提交"
          position="center"
          message="请再次确认是否要通过？"
          @ok="confirmApprove"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime } from '../../../utils/common'
import auditingCourseApi from '../../../api/auditingCourse'
import { CONSULTING_AUDIT_TYPES } from '../../../utils/constants'

export default {
  data () {
    return {
      insertData: {
        id: null,
        uid: null,
        topic: '',
        duration: '',
        price: '',
        description: '',
        sortNum: null,
        mentorUid: null,
        createTime: '',
        candidate: [],
      },
      message: ['Required field'],
      showId: false,
      showUid: false,
      showCreatedAt: false,
      disableMentor: false,
      title: '导师咨询审核',
      status: null,
      statusOptions: ['审核中', '已通过', '已下架'],
      submitButtonStatus: true,
      consultingAuditTypes: CONSULTING_AUDIT_TYPES,
      approveModal: false,
      rejectModal: false,
    }
  },
  created () {
    const params = this.$route.params
    if (params.uid != null) {
      this.showId = true
      this.showUid = true
      this.showCreatedAt = true
      this.disableMentor = true
      // 通过id获取详情
      auditingCourseApi.getAuditingConsulting(params.uid).then(response => {
        copyObject(response.auditingConsulting, this.insertData)
        this.insertData.createTime = formatTime(this.insertData.createTime)
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    this.listMentor()
  },
  computed: {

  },
  methods: {
    resetStatus () {
      this.status = null
    },
    processConsulting (status) {
      this.changeButtonStatus(false)
      const data = {
        uid: this.insertData.uid,
        status: status,
      }
      if (data.uid !== null) {
        auditingCourseApi.processAuditingConsulting(data.uid, data).then(response => {
          if (response.success === true) {
            this.changeButtonStatus(true)
            if (status === this.consultingAuditTypes.APPROVED.CODE) {
              this.showToast('审核通过，请确认并完善咨询信息', {
                duration: 6000,
                icon: 'fa-success',
                position: 'top-center',
                fullWidth: false,
              })
              this.$router.push({ name: 'updateConsulting', path: `/admin/consultings/updateConsulting/${data.uid}` })
            } else {
              this.showToast('更新成功', {
                duration: 1000,
                icon: 'fa-success',
                position: 'top-center',
                fullWidth: false,
              })
              this.$router.push({ name: 'listAuditingConsulting' })
            }
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
        this.rejectModal = false
        this.approveModal = false
      }
    },
    clickCancel () {
    },
    checkField () {
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    confirmApprove () {
      this.processConsulting(this.consultingAuditTypes.APPROVED.CODE)
    },
    confirmReject () {
      this.processConsulting(this.consultingAuditTypes.REJECTED.CODE)
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
